import React from 'react';

// TODO: Use ToastContext.ts instead in commerce/common/context
const ToastContext = React.createContext({});
export default ToastContext;
